export const WEB_HLS_COLD_START_BANDWIDTH_BPS = 10_000_000;
/** Keep premium 4K eligible independent of the inline player's CSS size. */
export const WEB_HLS_CAP_LEVEL_TO_PLAYER_SIZE = false;

const MIN_SHARED_BANDWIDTH_BPS = 100_000;
const MAX_SHARED_BANDWIDTH_BPS = 1_000_000_000;

/**
 * hls.js may briefly expose NaN or an unbounded loader value while an engine
 * is attaching. Only carry a real, bounded throughput estimate into the
 * sibling queue player.
 */
export function sharedWebQueueBandwidthEstimate(value: number) {
  if (!Number.isFinite(value) || value < MIN_SHARED_BANDWIDTH_BPS) return null;
  return Math.min(value, MAX_SHARED_BANDWIDTH_BPS);
}
